import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { ProfileImageUploadService } from '@app/core/_services/profile-image-upload.service'
import { UserService } from '@app/core/_services/user.service'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { faMicrophoneSlash, faStar } from '@fortawesome/pro-solid-svg-icons'
import { ButtonModule } from 'primeng/button'
import { take } from 'rxjs'

const BLANK_PROFILE_IMAGE = 'assets/images/blank_profile.png'

export type FmAvatarSize = 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'dynamicPanelView' | 'profileView'

@Component({
    selector: 'fm-avatar',
    imports: [CommonModule, FontAwesomeModule, ButtonModule],
    templateUrl: './fm-avatar.component.html',
    styleUrl: './fm-avatar.component.scss',
})
export class FmAvatarComponent {
    @Input() isSaved: boolean = false
    @Input() isSnoozed: boolean = false
    @Input() isQuietMode: boolean = false
    @Input() avatarLocation: string
    @Input() icon: any = null
    @Input() size: string = 'md'
    @Input() uploadImageEnabled: boolean = false

    public userAvatar: string
    faStar = faStar
    faMicrophoneSlash = faMicrophoneSlash
    uploadPhotoFile = null

    constructor(
        private userService: UserService,
        private profileImageUploadService: ProfileImageUploadService,
    ) {}

    ngOnInit(): void {}

    ngOnChanges() {
        this.userAvatar = this.avatarLocation || BLANK_PROFILE_IMAGE
    }

    public onProfileImageFailedToLoad() {
        this.userAvatar = BLANK_PROFILE_IMAGE
    }

    onFileChange(event) {
        if (event.target.files.length !== 1) {
            // No file selected or too many selected
            this.resetFileInput()
        } else {
            if (!this.profileImageUploadService.isValidFileFormat(event)) {
                // Error case - not a valid format
                this.resetFileInput()
            } else if (!this.profileImageUploadService.isValidFileSize(event)) {
                // Error case - too large
                this.resetFileInput()
            } else {
                this.uploadPhotoFile = event.target.files[0]

                this.userService.currentUser.pipe(take(1)).subscribe((user) => {
                    this.userService.update(user, this.uploadPhotoFile).subscribe({
                        error: (e) => this.resetFileInput(),
                    })
                })
            }
        }
    }

    resetFileInput() {
        this.uploadPhotoFile = null
        this.userAvatar = this.avatarLocation
    }
}
